import React from 'react';
import ListValidationError from '@/components/errors/ListValidationError';
import { camelConverter } from '../helper';

const FormListItemObjectContainer = ({
  children,
  field,
  hideLabel,
  hasLabel,
  error,
}) => (
  <>
    {hasLabel && !hideLabel && (
      <ListValidationError
        htmlFor={camelConverter(field.name, '_')}
        labelText={field.validation?.required ? `${field.label} *` : field.label}
        error={error}
      />
    )}
    {children}
  </>
);

export default FormListItemObjectContainer;
